import React, { useContext, useEffect } from 'react';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { estadoCivil, sexo, tipoDocumentos } from '../../data/mochaData';
import useToken from '../../hooks/useToken';
import { amaDeCasa, estudiante, tipoId } from '../../utils/constanst';
import CustomSelect from '../controls/CustomSelect';
import DateControl from '../controls/DateControl';
import DropDownInput from '../controls/DropDownInput';
import Input from '../controls/Input';
import InputFile from '../controls/InputFile';
import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';

const Step5 = ({ ...rest }) => {



    const { poliza, setPoliza, polizaChangeHandler } = useContext(CotizadorCRDataContext);


    return (
        <div className="reponsive">
            <div className="reponsive-width-12 box-pl5-pr5 lfheader">
                <label>Actividad Económica</label>
            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">
                    {/* <InputSelect containBlank={true} label='Actividad Economica' field='actividad' value={poliza.actividad} onChange={polizaChangeHandler} dataProvider='entities/0/economicActivities' /> */}
                    <Input label='Empresa donde trabaja' field='empresaTrabaja' value={poliza.empresaTrabaja} onChange={polizaChangeHandler} required={poliza.actividad !== amaDeCasa && poliza.actividad !== estudiante} />
                    <Input label='Telefono de empresa' type='maskInput' mask='9999-9999' field='telefono' placeholder='0000-0000' value={poliza.telefono} onChange={polizaChangeHandler} required={poliza.actividad !== amaDeCasa && poliza.actividad !== estudiante} />

                </div>
            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">
                   {/*<InputSelect label='Ocupacion' field='ocupacion' value={poliza.ocupacion} onChange={polizaChangeHandler} dataProvider='ocupacion' />*/ } 
                   {/*<InputSelect label='Ingreso Mensual' field='ingresoMensual' value={poliza.moneda} dataProvider={[{ "text": "DOLARES", "value": "U$" }]} onChange={polizaChangeHandler} containBlank={true} />*/ } 
                    <Input type='number' min="1" label='IngresoMensual en $' field='ingresoMensual' value={poliza.ingresoMensual} onChange={polizaChangeHandler} />
                  
                    <InputSelect label='Origen de fondo' field='origenFondo' value={poliza.origenFondo} onChange={polizaChangeHandler} dataProvider='origenFondo' />
                    {
                        poliza.origenFondo === 'ND' &&
                        <Input type='textarea' label='Explique el origen de fondo' field='origenFondoOtros' value={poliza.origenFondoOtros} onChange={polizaChangeHandler} />
                    }
                </div>
            </div>
        </div>
    );
}

export default Step5;
